module.exports = __webpack_public_path__ + "static/slusarczyk_logo-7ba8e6434158b7d1b95606d1844df0f7.png";